import { useState, useEffect } from 'react'
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ko } from 'date-fns/locale/ko'
import { Box } from '@mui/material';
import Icon_Calender from '@mui/icons-material/CalendarTodayOutlined';
import { usePromoAddInterest } from 'src/stores/PromoStore';

//DatePickerCustom
//DatePicker 컴포넌트

//작동에는 문제가 없으나 포커스 에러로그가 출력되는 현상이 있음 -> 수정필요함

const safeToDate = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;
  return typeof value === 'string' ? new Date(value) : value;
};

const DatePickerInterestedAddRecentDate = () => {
  const start_date = usePromoAddInterest((state)=>state.recent_date)
  const setField = usePromoAddInterest((state)=>state.setField)
  const [startDate, setStartDate] = useState<Date | null>(safeToDate(start_date));
  const [open,setOpen] = useState(false)

  useEffect(() => {
    setStartDate(safeToDate(start_date));
  }, [start_date]);

  const handleStart = (newValue: Date | null) => {
    setStartDate(newValue);
    if (newValue) {
      setField('recent_date',newValue.toString())
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
      <Box display="flex" alignItems="center" gap="5px">
        <DatePicker
          open={open}
          onOpen={()=>setOpen(true)}
          onClose={()=>setOpen(false)}
          value={startDate}
          onChange={handleStart}
          format="yyyy-MM-dd"
          slotProps={{
            textField: {
              //박스크기 스타일조정
              sx: {
                height:46,
                width:'100%',
                '& .MuiInputBase-root': {
                  height: 46,
                },
              },
              //내부 이미지 조정
              InputProps: {
                endAdornment: (
                  <Icon_Calender sx={{color:'#969696'}}/>
                ),
                onClick:()=>setOpen(true)
              },
            },
          }}
          slots={{
            toolbar: undefined, // ✅ 상단 선택된 날짜 텍스트 제거
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}

export default DatePickerInterestedAddRecentDate